import { Box, Typography } from "@mui/material";
import { BORDER, METRIC_CONFIG } from "./constants";

const MetricsBar = ({ metricType, metricCounts, onMetricChange }) => (
  <Box
    sx={{
      display: "flex",
      gap: 1,
      px: 2.5,
      py: 1.25,
      backgroundColor: "#f9fafb",
      borderBottom: BORDER,
      flexWrap: "wrap",
    }}
  >
    {Object.entries(METRIC_CONFIG).map(([key, cfg]) => {
      const isActive = key === metricType;
      const count = metricCounts[key] ?? 0;
      const CfgIcon = cfg.Icon;
      const clickable = !isActive && typeof onMetricChange === "function";
      return (
        <Box
          key={key}
          onClick={clickable ? () => onMetricChange(key) : undefined}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            px: 1.25,
            height: 28,
            backgroundColor: isActive ? cfg.bgColor : "#fff",
            border: isActive ? `1px solid ${cfg.color}` : BORDER,
            borderRadius: "8px",
            cursor: clickable ? "pointer" : "default",
            transition: "background 0.15s, border 0.15s",
            "&:hover": clickable
              ? {
                  backgroundColor: cfg.bgColor,
                  borderColor: cfg.color,
                }
              : {},
          }}
        >
          <CfgIcon
            sx={{
              fontSize: 13,
              color: isActive ? cfg.color : "text.secondary",
            }}
          />
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: isActive ? 500 : 400,
              color: isActive ? cfg.color : "text.primary",
            }}
          >
            {cfg.chipLabel}
          </Typography>
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 500,
              lineHeight: 1,
              color: isActive ? cfg.color : "text.secondary",
              ml: 0.25,
            }}
          >
            {count}
          </Typography>
        </Box>
      );
    })}
  </Box>
);

export default MetricsBar;
